import {
  ActionButton,
  Avatar,
  Item,
  Menu,
  MenuTrigger,
  Section,
  Text,
} from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import User from "@spectrum-icons/workflow/User"
import Logout from "@spectrum-icons/workflow/LogOut"
import Info from "@spectrum-icons/workflow/Info"
import Help from "@spectrum-icons/workflow/Help"
import { LocalStorage } from "@/helpers/LocalStorage.ts"
import { useNavigate } from "react-router"
import avatar from "@/assets/images/AdobeDefaultAvatar.png"

export function ProfileButton() {
  const navigate = useNavigate()

  function onActionMenuClick(key: string | number) {
    if (key === "logout") {
      LocalStorage.removeSecret("token")
      void navigate("/login")
    }
  }

  return (
    <MenuTrigger>
      <ActionButton UNSAFE_style={{ border: "none" }}>
        <Avatar
          src={avatar}
          alt="default Adobe avatar"
        />
      </ActionButton>
      <Menu onAction={onActionMenuClick} minWidth="size-2400">
        <Section aria-label="user details">
          <Item key="username">
            <User size="XXL" />
            <Text>{LocalStorage.getSecret("username")}</Text>
            <Text slot="description">
              ID: {LocalStorage.getSecret("userId")}
            </Text>
          </Item>
        </Section>

        <Section aria-label="help section">
          <Item key="about">
            <Info size="XL" />
            <Text>About</Text>
          </Item>
          <Item key="help">
            <Help size="L" />
            <Text>Help</Text>
          </Item>
        </Section>
        <Section aria-label="user section">
          <Item key="settings">Account Settings</Item>
          <Item key="logout">
            <Logout size="L" />
            <Text>Logout</Text> <Text slot="description">Logged in at</Text>
          </Item>
        </Section>
      </Menu>
    </MenuTrigger>
  )
}
